// @flow

import React from 'react';
import styled from 'styled-components';
import { COLORS, SPACING } from 'clark-styles';
import CloseButton from 'assets/icons/close.svg';

const { GREY_100 } = COLORS;
const { S_05, S_1 } = SPACING;

const CancelButton = ({ onClick }: { onClick(): void }) => (
  <ButtonWrapper onClick={onClick} aria-label="dismiss modal" title="close">
    <CloseButton />
  </ButtonWrapper>
);

const SIZE = '13px';
const POSITIONING = `calc(${S_05} + ${S_1})`;
export const ButtonWrapper = styled.button`
  cursor: pointer;
  border: none;
  color: ${GREY_100};
  height: ${SIZE};
  outline: 0;
  padding: 0;
  position: absolute;
  right: ${POSITIONING};
  top: ${POSITIONING};
  width: ${SIZE};
`;

export default CancelButton;



// WEBPACK FOOTER //
// ./src/components/button-cancel/index.js